import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { settingsAPI } from '../services/api';
import './About.css';

const formatStat = (value, cap) => (value > cap ? `${cap}+` : String(value));

const About = () => {
  const [stats, setStats] = useState([
    { number: '500+', label: 'نوع قطع غيار' },
    { number: '50+', label: 'موديل سيارة' },
    { number: '1000+', label: 'عميل راضٍ' },
    { number: '10+', label: 'سنوات خبرة' }
  ]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    settingsAPI.getHomeStats()
      .then((res) => {
        const { models_count, spare_parts_count, satisfied_customers } = res.data;
        setStats([
          { number: formatStat(spare_parts_count, 500), label: 'نوع قطع غيار' },
          { number: formatStat(models_count, 50), label: 'موديل سيارة' },
          {
            number: satisfied_customers > 1000 ? String(satisfied_customers) : '1000+',
            label: 'عميل راضٍ'
          },
          { number: '10+', label: 'سنوات خبرة' }
        ]);
      })
      .catch(() => {});
  }, []);

  const features = [
    { icon: '🚗', title: 'قطع أصلية 100%', description: 'جميع قطع الغيار أصلية ومضمونة من مرسيدس بنز' },
    { icon: '⚡', title: 'توصيل سريع', description: 'خدمة توصيل سريعة وآمنة لجميع أنحاء ليبيا' },
    { icon: '💰', title: 'أسعار منافسة', description: 'أفضل الأسعار في السوق مع ضمان الجودة' },
    { icon: '🔧', title: 'دعم فني متخصص', description: 'فريق متخصص لمساعدتك في اختيار القطع المناسبة' },
    { icon: '📱', title: 'تواصل مباشر', description: 'تواصل معنا عبر واتساب للحصول على استجابة فورية' },
    { icon: '✅', title: 'ضمان الجودة', description: 'جميع القطع مضمونة ومختبرة قبل البيع' }
  ];

  const services = [
    {
      title: 'قطع خارجية',
      description: 'جميع القطع الخارجية لسيارات مرسيدس: الصدامات، الإضاءة، المرايا، الشبك، الكبوت، وغيرها',
      items: ['صدامات أمامية وخلفية', 'مصابيح LED و HID', 'مرايا جانبية', 'شبك أمامي', 'كبوت وغطاء خلفي']
    },
    {
      title: 'اختيار تفاعلي',
      description: 'استخدم نظامنا التفاعلي لاختيار القطع المناسبة لسيارتك بسهولة',
      items: ['عرض 360 درجة', 'اختيار تفاعلي', 'صور عالية الجودة', 'معلومات مفصلة']
    },
    {
      title: 'دعم متكامل',
      description: 'نوفر لك الدعم الكامل من اختيار القطعة حتى التوصيل',
      items: ['استشارة مجانية', 'دعم فني', 'توصيل سريع', 'ضمان الجودة']
    }
  ];

  return (
    <div className="about-page">
      <section className="about-hero">
        <div className="container">
          <h1 className="about-hero-title">من نحن</h1>
          <p className="about-hero-subtitle">
            حمزة لقطع غيار مرسيدس بنز — ثقتكم هي أولويتنا منذ أكثر من 10 سنوات
          </p>
        </div>
      </section>

      <section className="stats-section">
        <div className="container">
          <div className="stats-grid">
            {stats.map((stat, index) => (
              <div key={index} className="stat-item">
                <div className="stat-number">{stat.number}</div>
                <div className="stat-label">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="features-section" className="features-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">لماذا نحن الأفضل؟</h2>
            <p className="section-subtitle">
              نقدم لك أفضل تجربة تسوق لقطع غيار مرسيدس مع ضمان الجودة والخدمة الممتازة
            </p>
          </div>
          <div className="features-grid">
            {features.map((feature, index) => (
              <div key={index} className="feature-card">
                <div className="feature-icon">{feature.icon}</div>
                <h3 className="feature-title">{feature.title}</h3>
                <p className="feature-description">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="services-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">خدماتنا</h2>
            <p className="section-subtitle">
              نوفر لك مجموعة شاملة من الخدمات لتلبية جميع احتياجاتك
            </p>
          </div>
          <div className="services-grid">
            {services.map((service, index) => (
              <div key={index} className="service-card">
                <h3 className="service-title">{service.title}</h3>
                <p className="service-description">{service.description}</p>
                <ul className="service-list">
                  {service.items.map((item, itemIndex) => (
                    <li key={itemIndex} className="service-item">
                      <span className="service-check">✓</span>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="why-us-section">
        <div className="container">
          <div className="why-us-content">
            <div className="why-us-text">
              <h2 className="section-title">لماذا تختار حمزة؟</h2>
              <div className="why-us-points">
                <div className="why-us-point">
                  <div className="why-us-icon">🏆</div>
                  <div>
                    <h4>خبرة طويلة</h4>
                    <p>أكثر من 10 سنوات من الخبرة في مجال قطع غيار مرسيدس</p>
                  </div>
                </div>
                <div className="why-us-point">
                  <div className="why-us-icon">🔒</div>
                  <div>
                    <h4>جودة مضمونة</h4>
                    <p>جميع القطع أصلية 100% مع ضمان الجودة والصلاحية</p>
                  </div>
                </div>
                <div className="why-us-point">
                  <div className="why-us-icon">🚚</div>
                  <div>
                    <h4>توصيل سريع</h4>
                    <p>خدمة توصيل سريعة وآمنة لجميع أنحاء ليبيا</p>
                  </div>
                </div>
                <div className="why-us-point">
                  <div className="why-us-icon">💬</div>
                  <div>
                    <h4>دعم فني</h4>
                    <p>فريق متخصص جاهز لمساعدتك في أي وقت</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2 className="cta-title">جاهز للبدء؟</h2>
            <p className="cta-subtitle">
              ابحث عن القطع التي تحتاجها لسيارتك الآن واحصل على أفضل الأسعار
            </p>
            <Link to="/#models-section" className="btn btn-primary btn-large cta-btn">
              تصفح الموديلات
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
